import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, Divider, Fab, InputBase, withWidth} from '@material-ui/core';
import {ArrowForward} from '@material-ui/icons';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 12,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  menuItem: {
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textDecoration: 'none',
    paddingBottom: theme.spacing.unit * 2,
    fontSize: theme.spacing.unit * 1.5,
    textTransform: 'uppercase',
    '&:hover': {
      color: theme.palette.primary.light
    },
    '&:focus': {
      color: '#FFF'
    }
  },
  input: {
    width: '100%',
  },
  logo: {
    maxWidth: 100
  },
  customInput: {
    color: theme.palette.text.secondary,
    borderRadius: 20,
    backgroundColor: theme.palette.primary.dark,
    width: '100%',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    marginRight: theme.spacing.unit * 2,
    '&:focus': {
      borderColor: theme.palette.secondary.main
    },
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main
  },
  socialIcon: {
    width: 36,
    height: 36,
    padding: theme.spacing.unit
  }
});

const Footer = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    <Grid container direction="column" spacing={32}>
      <Grid item>
        <Grid container direction="row" justify="space-around" alignItems="stretch" spacing={40} item>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" justify="space-between" spacing={16}>
              <Grid item>
                <img src="/images/logo-white.png" alt="Logo" className={classes.logo}/>
              </Grid>
              <Grid item>
                <Typography variant="caption">
                  Issued in the Interest of the Customer : Usage of Cryptocurrencies is considered to be high risk.
                  Please beware that the regulation of Cryptocurrencies is a fluidic landscape, subject to sudden
                  changes. You might lose all of the value inherent in a Cryptocurrency. No regulatory body guarantees
                  the return of any value lost. .
                </Typography>
              </Grid>
              <Grid item>
                <a href="https://www.facebook.com/CryptxFinancial" target="_blank" className={classes.link}>
                  <img src="/images/icons/social/facebook.svg" alt="Icon" className={classes.socialIcon}/>
                </a>
                <a href="https://twitter.com/CryptxFinancial" target="_blank" className={classes.link}>
                  <img src="/images/icons/social/twitter.svg" alt="Icon" className={classes.socialIcon}/>
                </a>
                <a href="https://www.linkedin.com/company/cryptx-financial" target="_blank" className={classes.link}>
                  <img src="/images/icons/social/linkedin-colored.svg" alt="Icon" className={classes.socialIcon}/>
                </a>
                <a href="https://t.me/cryptxFinancial" target="_blank" className={classes.link}>
                  <img src="/images/icons/social/telegram.svg" alt="Icon" className={classes.socialIcon}/>
                </a>
                <a href="https://www.youtube.com/channel/UCdI6WxUTLoCFVDfjHqShWWg" target="_blank" className={classes.link}>
                  <img src="/images/icons/social/youtube.svg" alt="Icon" className={classes.socialIcon}/>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" spacing={16}>
              <Grid item>
                <Typography variant="caption">MENU</Typography>
              </Grid>
              <Grid item>
                <Grid container direction="row" wrap="wrap" justify="space-between" alignItems="center" spacing={16}>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Home</a></Grid>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Tradding View</a></Grid>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Pricing</a></Grid>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Contact Us</a></Grid>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Invest</a></Grid>
                  <Grid item xs={6}><a href="#" className={classes.menuItem}>Blog</a></Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" justify="space-between" spacing={16}>
              <Grid item>
                <Typography variant="h6">SUBMIT FOR UPDATES</Typography>
              </Grid>
              <Grid item>
                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={10}>
                    <InputBase type="text" placeholder="email" className={classes.input} classes={{
                      input: classes.customInput,
                    }}/>
                  </Grid>
                  <Grid item xs={2}>
                    <Fab variant="extended" size="medium" color="secondary">
                      <ArrowForward fontSize="small"/>
                    </Fab>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Divider/>
      </Grid>
      <Grid item>
        <Grid container direction="row">
          <Grid item xs={6}>
            <Typography variant="caption">Copyright © 2018 CryptX Financial S.A. All rights reserved</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" align="right">
              <a className={classes.link} target="_blank" href="https://ico.cryptx.financial/Terms/terms.html">
                Terms of Use
              </a> |
              <a className={classes.link} target="_blank"
                 href="https://ico.cryptx.financial/Terms/privacy.html"> Privacy Statement </a> |
              <a className={classes.link} target="_blank"
                 href="https://ico.cryptx.financial/Terms/security.html"> Security </a> |
              <a className={classes.link} target="_blank"
                 href="https://ico.cryptx.financial/Terms/Investment_Risk.html"> Risk </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </div>
));

export default withWidth()(Footer);
